<template>
  <v-app>
    <v-app-bar app>
      <v-btn icon @click.stop="navigacio = !navigacio" class="d-lg-none"><v-icon>fa-bars</v-icon></v-btn>
      <v-toolbar-title class="headline text-uppercase">
        <span>DigiKoli</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-img class="shrink" max-width="34" min-width="34" transition="scale-transition" :src="`${$store.state.backendeleres}dynamic/logo.png`"/>
    </v-app-bar>
    <v-navigation-drawer
      :expand-on-hover="$vuetify.breakpoint.name=='lg' || $vuetify.breakpoint.name=='xl'"
      app
      v-model="navigacio"
    >
      <v-list nav>
        <router-link  v-if="!$store.state.bejelentkezve" :to="{name: 'home'}">
          <v-list-item contenteditable="">
            <v-list-item-icon><v-icon>fa-home</v-icon></v-list-item-icon>
            <v-list-item-content>Kezdőlap</v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link  v-if="!$store.state.bejelentkezve" :to="{name: 'bejelentkezes'}">
          <v-list-item>
            <v-list-item-icon><v-icon>fa-sign-in-alt</v-icon></v-list-item-icon>
            <v-list-item-content>Bejelentkezés</v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link v-if="$store.state.bejelentkezve" :to="{ name: 'profil' }">
          <v-list-item>
            <v-list-item-icon><v-icon>fa-user-edit</v-icon></v-list-item-icon>
            <v-list-item-content>Profil</v-list-item-content>
          </v-list-item>
        </router-link>

        <router-link v-if="$store.state.bejelentkezve&&$store.state.minosites<0" :to="{ name: 'informaciok' }">
          <v-list-item>
            <v-list-item-icon><v-icon>fa-info-circle</v-icon></v-list-item-icon>
            <v-list-item-content>Információk</v-list-item-content>
          </v-list-item>
        </router-link>

        <v-list-group v-if="$store.state.bejelentkezve&&$store.state.minosites<0"
          prepend-icon="fa-broom"
        >
          <template v-slot:activator>
            <v-list-item-title>Szobapontozás</v-list-item-title>
          </template>
          <router-link v-if="$store.state.bejelentkezve&&$store.state.minosites<0" :to="{ name: 'napiszobapontozas' }">
            <v-list-item>
              <v-list-item-icon><v-icon>fa-star</v-icon></v-list-item-icon>
              <v-list-item-content>Napi szobapontozás</v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link v-if="$store.state.bejelentkezve&&$store.state.minosites<0" :to="{ name: 'hetiszobapontozasattekintes' }">
            <v-list-item>
              <v-list-item-icon><v-icon>fa-calendar-week</v-icon></v-list-item-icon>
              <v-list-item-content>Heti áttekintés</v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link v-if="$store.state.bejelentkezve&&$store.state.minosites<0" :to="{ name: 'szobapontozaskimutatas' }">
            <v-list-item>
              <v-list-item-icon><v-icon>fa-chart-bar</v-icon></v-list-item-icon>
              <v-list-item-content>Kimutatás</v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list-group>

        <router-link v-if="$store.state.bejelentkezve&&$store.state.minosites>=0&&$store.state.diakJelolSzilenciumot" :to="{name: 'szilenciumbejegyzes'}">
          <v-list-item>
            <v-list-item-icon><v-icon>fa-user-check</v-icon></v-list-item-icon>
            <v-list-item-content>Szilenciumok bejegyzése</v-list-item-content>
          </v-list-item>
        </router-link>

        <router-link v-if="$store.state.bejelentkezve&&$store.state.minosites>=0&&$store.state.diakJelolSzilenciumot&&$store.state.diakJelolTermet" :to="{name: 'teremvalasztasKollegista'}">
          <v-list-item>
            <v-list-item-icon><v-icon>fa-chalkboard-teacher</v-icon></v-list-item-icon>
            <v-list-item-content>Termek kiválasztása</v-list-item-content>
          </v-list-item>
        </router-link>

        <v-list-group v-if="$store.state.bejelentkezve&&$store.state.minosites<0"
          prepend-icon="fa-business-time"
        >
          <template v-slot:activator>
            <v-list-item-title>Szilencium</v-list-item-title>
          </template>

          <router-link v-if="$store.state.bejelentkezve&&$store.state.minosites<0" :to="{ name: 'szilenciumfoglalas' }">
            <v-list-item>
              <v-list-item-icon><v-icon>fa-user-times</v-icon></v-list-item-icon>
              <v-list-item-content>Szilenciumfoglalás</v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link v-if="$store.state.bejelentkezve&&$store.state.minosites<0" :to="{ name: 'szilenciumjelenletiiv' }">
            <v-list-item>
              <v-list-item-icon><v-icon>fa-address-book</v-icon></v-list-item-icon>
              <v-list-item-content>Jelenléti ív</v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link v-if="$store.state.bejelentkezve&&$store.state.minosites<0&&$store.state.diakJelolSzilenciumot" :to="{ name: 'szilenciumbejegyzesekmodositasa' }">
            <v-list-item>
              <v-list-item-icon><v-icon>fa-user-check</v-icon></v-list-item-icon>
              <v-list-item-content>Bejegyzések módosítása</v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link v-if="$store.state.bejelentkezve&&$store.state.minosites<0&&$store.state.diakJelolSzilenciumot" :to="{ name: 'nemelegszilenciumotvalasztottak' }">
            <v-list-item>
              <v-list-item-icon><v-icon>fa-eye</v-icon></v-list-item-icon>
              <v-list-item-content>Tanulók bejegyzési hiányai</v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link v-if="$store.state.bejelentkezve&&$store.state.minosites<0" :to="{ name: 'szilenciumtelitettseg' }">
            <v-list-item>
              <v-list-item-icon><v-icon>fa-dot-circle</v-icon></v-list-item-icon>
              <v-list-item-content>Szilenciumtelítettség</v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link  v-if="$store.state.minosites==-2" :to="{name: 'szilenciumibejegyzessablonok'}">
            <v-list-item>
              <v-list-item-icon><v-icon>fa-magic</v-icon></v-list-item-icon>
              <v-list-item-content>Szilenciumi bejegyzés sablonok</v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list-group>
        <router-link v-if="$store.state.minosites<0" :to="{name: 'kiesbelepesek'}">
          <v-list-item>
            <v-list-item-icon><v-icon>fa-door-open</v-icon></v-list-item-icon>
            <v-list-item-content>Aktuális helyzetek</v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link v-if="$store.state.minosites<0" :to="{name: 'kiesbelepesnaplo'}">
          <v-list-item>
            <v-list-item-icon><v-icon>fa-book</v-icon></v-list-item-icon>
            <v-list-item-content>Ki- és belépések naplója</v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link  v-if="$store.state.minosites<0" :to="{name: 'szakkorok'}">
          <v-list-item>
            <v-list-item-icon><v-icon>fa-lightbulb</v-icon></v-list-item-icon>
            <v-list-item-content>Szakkörök</v-list-item-content>
          </v-list-item>
        </router-link>

        <!--<router-link  v-if="$store.state.minosites<0" :to="{name: 'nyomtatas'}">
          <v-list-item>
            <v-list-item-icon><v-icon>fa-print</v-icon></v-list-item-icon>
            <v-list-item-content>Nyomtatás</v-list-item-content>
          </v-list-item>
        </router-link>-->

        <router-link  v-if="$store.state.minosites==-2" :to="{name: 'admin'}">
          <v-list-item>
            <v-list-item-icon><v-icon>fa-cog</v-icon></v-list-item-icon>
            <v-list-item-content>Alapadat-beviteli felület</v-list-item-content>
          </v-list-item>
        </router-link>


        <v-list-item>
          <v-list-item-icon><v-icon>fa-moon</v-icon></v-list-item-icon>
          <v-list-item-content><v-switch v-model="$vuetify.theme.dark" label="Sötét mód"></v-switch></v-list-item-content>
        </v-list-item>
      </v-list>
      <v-btn rounded color="red" block @click="kijelentkezes()" v-if="$store.state.bejelentkezve">
        <v-icon
          left
          dark
        >
          fa-sign-out-alt
        </v-icon>
        Kijelentkezés
      </v-btn>
    </v-navigation-drawer>
    <v-main>
      <v-img
        :min-height="minHeight"
        :src="`${$store.state.backendeleres}dynamic/background.jpg`"
        gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
      >
        <v-container fluid>
          <router-view class="view"></router-view>
        </v-container>
      </v-img>
    </v-main>
    <v-footer app class="justify-center">
      ©Vörös László
    </v-footer>
  </v-app>
</template>

<script>
     import router from "./router"
export default {
  name: 'App',
  components: {
  },
  data: function(){
    return {
      navigacio: this.$vuetify.breakpoint.name=='lg' || this.$vuetify.breakpoint.name=='xl',
    }
  },
  computed: {
		minHeight () {
			const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

			return `calc(${height} - ${this.$vuetify.application.top}px)`
	   },
   },
  methods: {
    kijelentkezes: function(){
      this.axios.get(this.$store.state.backendeleres+"kijelentkezes").then((response) => {
      this.$store.commit('bejelentkezve', response.data.bejelentkezve)
      if(!response.data.bejelentkezve){
        router.push('/bejelentkezes');
        this.$store.commit('minosites',0)
      }
      })
    }
  },
  mounted (){
    this.axios.get(this.$store.state.backendeleres+"hitelesites/bejelentkezve")
    .then(response => {
      this.$store.dispatch('bejelentkezesallasvaltas', response.data.bejelentkezve)
      if(response.data.bejelentkezve){
         this.axios.get(this.$store.state.backendeleres+"hitelesites/minosites").then((response) =>{
            this.$store.commit('minosites',response.data.minosites);
            this.$store.commit('diakJelolSzilenciumot',response.data.diakJelolSzilenciumot)
            this.$store.commit('diakJelolTermet',response.data.diakJelolTermet)
          })
          this.$store.commit('id',response.data.id)
      }
      else this.$store.commit('minosites',0)
    })

  }
}
</script>
